'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../../node_modules/@radix-ui/react-dropdown-menu/dist/index.cjs');
var Divider_web = require('../../../atoms/Divider/Divider.web.cjs');
var Typography_web = require('../../../atoms/Typography/Typography.web.cjs');
var Group_styles = require('./Group.styles.cjs');

/**
 * Subcomponent of Dropdown. Is a group within a DropdownMenu.
 *
 * @scope Web
 */ const Group = ({ children, label, showSeparator = true, ...rest })=>{
    return /*#__PURE__*/ jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [
            showSeparator && /*#__PURE__*/ jsxRuntime.jsx(Divider_web.Divider, {
                customCss: Group_styles.separator
            }),
            label && /*#__PURE__*/ jsxRuntime.jsx(index.Label, {
                ...rest,
                css: Group_styles.sectionHeading,
                children: /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                    variant: "callout",
                    as: "span",
                    fontWeight: "bold",
                    isMarginless: true,
                    children: label
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx(index.Group, {
                ...rest,
                css: Group_styles.group,
                children: children
            })
        ]
    });
};
Group.displayName = "DropdownMenu.Group";

exports.Group = Group;
//# sourceMappingURL=Group.web.cjs.map
